import React from 'react';

import { BreadcrumbItemType, BreadcrumbSeparatorType } from 'antd/es/breadcrumb/Breadcrumb';

import {
	griefText,
	griefTitle,
	helpingAnimalsText,
	helpingAnimalsTitle,
	helpingBooksList,
	helpingBooksTitle,
	helpingList,
	lossBooksList,
	lossBooksTitle,
	specificInfoList,
	specificInfoTitle,
} from '@app/components/Pages/PetLossChildrenGrief/PetLossChildrenGriefContent';
import CardLinks from '@app/components/UI/CardLinks/CardLinks';
import HelmetProvider from '@app/components/UI/HelmetProvider/HelmetProvider';
import Masthead from '@app/components/UI/MastHead/Masthead';
import RichText from '@app/components/UI/RichText/RichText';

const PetLossChildrenGrief = () => {
	const [breadcrumbs, setBreadcrumbs] = React.useState<Array<Partial<BreadcrumbItemType & BreadcrumbSeparatorType>> | undefined>();

	React.useEffect(() => {
		const bc: Array<Partial<BreadcrumbItemType & BreadcrumbSeparatorType>> | undefined = [
			{
				path: '/pet-loss-support-resources',
				title: 'Pet Loss Support Resources',
			},
			{
				path: '',
				title: 'Children and Pet Grief Resources',
			},
		];

		setBreadcrumbs(bc);
	}, []);

	return (
		<HelmetProvider>
			<div className="pet-loss-grief">
				<Masthead
					title="Grief Resources for Children and Pets"
					imageSrc={require('@app/content/petLossChildrenGriefHeader.jpg')}
					breadcrumbs={breadcrumbs}
					backPath={{
						path: '/pet-loss-support-resources',
						name: 'Back to pet loss support resources',
					}}
					imageAlt="Children loss of pet"
				/>

				<RichText title={griefTitle} text={griefText} />
				<CardLinks list={helpingList} />

				<RichText text={helpingBooksTitle} />
				<CardLinks list={helpingBooksList} />

				<RichText text={lossBooksTitle} />
				<CardLinks list={lossBooksList} />

				<RichText title={helpingAnimalsTitle} text={helpingAnimalsText} />

				<RichText text={specificInfoTitle} />
				<CardLinks list={specificInfoList} />
			</div>
		</HelmetProvider>
	);
};

export default PetLossChildrenGrief;
